// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Vlkj","row":"Node_row__1WiPn","label":"Node_label__cEMuw","footer":"Node_footer__2BSKD"};